export function clearLocalStorageAndReload() {
	localStorage.clear();
	window.location.reload();
}
